<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" title="设置任务模板" custom-class="custom-dialog" :close-on-click-modal="false"
                    @opened="dialogOpen" @closed="dialogClose" width="790px">
            
            <div style="display: inline-block; height:40px;">
                <el-input v-model="queryForm.dimensionName" placeholder="类别名称" style="width: 150px;" ></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="queryForm.name" placeholder="任务模板名称" style="width: 150px;" ></el-input>
            </div>
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary" plain @click="setAdd">添加任务模板</el-button>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                v-loading="loading"
                :element-loading-text = "loadingText"
                :default-expand-all="true"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="任务图标"  :show-overflow-tooltip="true" width="70px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.compressUrl != null && scope.row.compressUrl != ''">
                                <el-popover
                                    placement="right"
                                    title=""
                                    trigger="hover">
                                    <img :src="scope.row.compressUrl" lazy="loading" style="max-height:250px; max-width:330px"/>
                                    <img slot="reference" :src="scope.row.compressUrl"  lazy="loading" style="max-height: 50px;max-width: 130px">
                                </el-popover>
                            </div>
                            <div v-else>
                                未上传
                            </div>
                        </template>
                    </el-table-column>
                <el-table-column prop="dimensionName" label="类别名称"  :show-overflow-tooltip="true" width="80"></el-table-column>
                <el-table-column prop="name" label="任务标题名称"  :show-overflow-tooltip="true" width="150"></el-table-column>
                <el-table-column prop="content" label="任务内容"  :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="绑定功能"  :show-overflow-tooltip="true" width="90">
                    <template slot-scope="scope">
                        <div v-if="scope.row.taskType == 2">打卡任务</div>
                        <div v-else-if="scope.row.taskType == 3">写实记录</div>
                        <div v-else-if="scope.row.taskType == 4">个人总结</div>
                        <div v-else-if="scope.row.taskType == 5">典型案例</div>
                        <div v-else-if="scope.row.taskType == 6">德育奖惩</div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="78px">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button  @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </el-dialog>
        <!-- 添加弹出框 -->
        <add-template-task v-model="addTemplateTaskVisible" :template="template" />
        <!-- 修改弹出框 -->
        <update-template-task v-model="updateTemplateTaskVisible" :template="template" :templateTask="selectTemplateTask"/>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import addTemplateTask from './addTemplateTask.vue';
    import updateTemplateTask from './updateTemplateTask.vue';

    export default {
        name: 'setTemplateTask',
        components: {addTemplateTask, updateTemplateTask},
        props: {
            value: Boolean,
            template: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        watch: {
            value(val) {
                this.dialogVisible = val
            },
            dialogVisible(val) {
                this.$emit('input', val)
            },
        },
        data(){
            return{
                loading: false,
                loadingText: "",
                dialogVisible: false,
                addTemplateTaskVisible: false,
                updateTemplateTaskVisible: false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[],       //多选框数组
                },
                queryForm:{
                    deptId: "",
                    templateId: "",
                    dimensionName:"",
                    name:"",
                },
                form:{
                    id:"",
                },
                data:[],
                selectTemplateTask: {}
            }
        },
        created:function () {
        },
        methods:{
            indexMethod(index) {
                return (index+1);
            },
            dialogOpen() {
                this.data = []
                if (this.$refs['queryForm'] != undefined) {
                    this.$refs['queryForm'].resetFields()
                }
                // 初始值
                this.queryForm.deptId = this.template.deptId
                this.queryForm.templateId = this.template.id
                 
                this.getData()
            },
            dialogClose(){
                this.dialogVisible = false
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //添加界面
            setAdd(){
                 this.addTemplateTaskVisible = true
            },
            //修改界面
            setUpdate(data){
                this.selectTemplateTask = data
                this.updateTemplateTaskVisible = true
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                this.loading=true;
                this.loadingText="数据删除中...";

                let url = this.clockinTemplateTaskRemoveUrl;
                let data = {
                    'id': this.form.id
                };
                // console.log('delBySchoolId',data)
                // return
                this.apiPost(url,data).then((res)=>{
                     this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            getData(){
                let url  = this.clockinTemplateTaskListUrl
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId: this.queryForm.deptId,
                    templateId: this.queryForm.templateId,
                    name: this.queryForm.name,
                    dimensionName: this.queryForm.dimensionName,
                };
                // console.log(data);
                this.loading=true
                this.apiPost(url,data).then((res) => {
                    if(res.status === 200){
                        this.data = res.data.list
                        this.common.total = res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/components/setTemplateTask.vue